import React from 'react';
import ReviewsComponent from './ReviewsComponent';
import CTASectionComponent from './CTASectionComponent';
import ServiceAreasComponent from './ServiceAreasComponent';
import ContactInfoComponent from './ContactInfoComponent';
import DualButtonCTAComponent from './DualButtonCTAComponent';
import HomeHeroComponent from './HomeHeroComponent';
import CardSectionComponent from './CardSectionComponent';
import ProductServiceListing from '../ProductServiceListing';

// Component registry
const componentRegistry = {
  reviews: ReviewsComponent,
  cta_section: CTASectionComponent,
  service_areas: ServiceAreasComponent,
  contact_info: ContactInfoComponent,
  dual_button_cta: DualButtonCTAComponent,
  home_hero: HomeHeroComponent,
  card_section: CardSectionComponent,
  product_listing: ProductServiceListing,
  footer: null, // Footer is managed globally, not rendered via CMS
};

// Renderer for CMS components
export const CMSComponentRenderer = ({ componentType, config }) => {
  const Component = componentRegistry[componentType];
  
  if (!Component) {
    console.warn(`Unknown CMS component type: ${componentType}`);
    return null;
  }
  
  return <Component config={config} />;
};

// Export individual components
export { ReviewsComponent, CTASectionComponent, ServiceAreasComponent, ContactInfoComponent, DualButtonCTAComponent, HomeHeroComponent, CardSectionComponent, ProductServiceListing };

export default CMSComponentRenderer;
